// extracted by mini-css-extract-plugin
module.exports = {"disclaimerForm":"_2M1qADqMYGB1Y0xbsHQL5n","removeListStyle":"_2PZ1ln3P-EYRuVl8EElV2S","boldAndUnderline":"_1H54VFyHwLi0hhnlfTQfar","inputGroup":"_37uAHFKcTQHezOAeDOqA23"};